import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Ban, Mail } from 'lucide-react'
import { useAuth } from '@/contexts/AuthContext'
import { toast } from 'sonner'

/**
 * Full-screen modal shown to suspended users
 * Cannot be dismissed - users can only sign out
 */
export function SuspendedModal() {
  const { signOut } = useAuth()

  const handleSignOut = async () => {
    try {
      await signOut()
    } catch (error) {
      toast.error('Failed to sign out')
    }
  }

  return (
    <Dialog open={true} onOpenChange={() => {}}>
      <DialogContent
        className="max-w-2xl [&>button]:hidden"
      >
        <DialogHeader className="text-center space-y-4">
          <div className="mx-auto w-16 h-16 rounded-full bg-destructive/10 flex items-center justify-center">
            <Ban className="w-8 h-8 text-destructive" />
          </div>
          <DialogTitle className="text-2xl">Intermission</DialogTitle>
          <DialogDescription className="text-base space-y-4">
            <p>
              Your account has been temporarily paused and you currently cannot access AionTrack.
            </p>
            <p>
              Check back shortly, or contact our support team if you need in sooner.
            </p>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 pt-4">
          <div className="bg-muted/50 rounded-lg p-4 space-y-3">
            <div className="flex items-start gap-3">
              <Mail className="w-5 h-5 text-muted-foreground mt-0.5" />
              <div className="flex-1 space-y-1">
                <p className="text-sm font-medium">Contact Support</p>
                <p className="text-sm text-muted-foreground">
                  Email us at <a href="mailto:aiontrack.app@gmail.com" className="underline">aiontrack.app@gmail.com</a> to
                  resolve this issue.
                </p>
              </div>
            </div>
          </div>

          <Button
            onClick={handleSignOut}
            variant="outline"
            className="w-full"
          >
            Sign Out
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  )
}
